import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaInput from '../Forms/TextareaInput';
import Avatar from '../Avatars/Avatar';
import Button from '../Buttons/Button';

export default class CommentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      commentText: '',
      commentLengthCheck: false,

    };
  }

  onChange = (e) => {
    this.setState({ commentText: e.target.value, commentLengthCheck: e.target.value.length >= 10 && !(/^\s+$/.test(e.target.value)) });
  }

  postComment = (e) => {
    e.preventDefault();
    this.props.onSubmit(this.state.commentText);
    this.setState({ commentText: ``, commentLengthCheck: false });

  }

  ifEnterPressed = (e) => {
    if (e.key === 'Enter') {
      this.postComment(e);
    }
  }

  render() {
    const { loggedInUser, placeholder, inputRef, btnText, submitting } = this.props;

    let commentForm;
    if (loggedInUser.computed_access) {
      commentForm = (
        <div className="comment-form-container">
          <Avatar
            size="s"
            image={loggedInUser.image_url}
          />

          <form className="comment-form">
            <TextareaInput
              name="reply"
              maxLength={1500}
              value={this.state.commentText}
              placeholder={placeholder}
              onChange={this.onChange}
              onKeyPress={this.ifEnterPressed}
              inputRef={inputRef}
              autoResize
              classes="flex-grow-1 m-b-0"
            />

            <Button
              onClick={this.postComment}
              size="s"
              disabled={!this.state.commentLengthCheck}
              loading={submitting}
            >
              {btnText}
            </Button>
          </form>
        </div>
      );
    } else {
      const currentPath = location.pathname;
      commentForm = (
        <div className="comment-form-container logged-out">
          <span>You must <a href={`/login?returnPath=${currentPath}`}>login</a> to post a comment, reply and like comments</span>
        </div>
      );
    }

    return commentForm;
  }
}

CommentForm.propTypes = {
  loggedInUser: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  inputRef: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  btnText: PropTypes.string.isRequired,
  submitting: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/CommentForm.js